import { createRouter, createWebHashHistory } from 'vue-router';
import HomeView from './views/drama/HomeView.vue';
import DiaryView from './views/drama/DiaryView.vue';
// import ScriptView from './views/ScriptView.vue';
import ResultView from './views/drama/ResultView.vue';
import LoginView from './views/LoginView.vue';
import ShakespeareView from './views/shakespeare/ShakespeareView.vue';
import SlowDramaView from './views/slow-drama/SlowDramaView.vue';
import SlowDramaDetailView from './views/slow-drama/SlowDramaDetailView.vue';
import { buildSlowDramaRoutes } from './config/slowDramaWorkflows';

const routes = [
  { path: '/login', name: 'Login', component: LoginView, meta: { page_title: '登录' } },
  { path: '/', name: 'Home', component: HomeView, meta: { requiresAuth: true, showSidebar: true, page_title: '短剧剧本创作' } },
  ...buildSlowDramaRoutes(SlowDramaView, SlowDramaDetailView),
  { path: '/diary', name: 'Diary', component: DiaryView, meta: { requiresAuth: true } },
  // { path: '/script', name: 'Script', component: ScriptView, meta: { requiresAuth: true } },
  { path: '/result', name: 'Result', component: ResultView, meta: { requiresAuth: true } },
  { path: '/shakespeare', name: 'Shakespeare', component: ShakespeareView, meta: { requiresAuth: true, page_title: '莎士比耶写作助手' } }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

// 检查用户是否已登录
const isAuthenticated = () => {
  const userInfo = localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo');
  return !!userInfo;
};

// 路由守卫
router.beforeEach((to, from, next) => {
  // 如果路由需要认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 检查是否已登录
    if (!isAuthenticated()) {
      // 未登录，重定向到登录页
      next({ name: 'Login' });
    } else {
      // 已登录，继续访问
      next();
    }
  } else if (to.name === 'Login' && isAuthenticated()) {
    // 如果已登录用户访问登录页，重定向到首页
    next({ name: 'Home' });
  } else {
    // 不需要认证的路由，直接访问
    next();
  }
});

export default router;
